import { orderBy } from 'lodash-es';

import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

import { MobileSdkTestIssueTypesQuery } from '../MobileSdkTestIssueTypes.generated';

export const transformMobileSdkTestIssueTypesResults = (
	rawResults: MobileSdkTestIssueTypesQuery
): MobileIssueTypeCount[] => {
	const issueTypes = rawResults.msdk_test_by_issue_types || [];

	// Calculate total issues across all types
	const totalIssues = issueTypes.reduce((sum, issueType) => sum + (issueType.total_issues || 0), 0);

	// Transform aggregated data into MobileIssueTypeCount objects and sort by count (descending)
	return orderBy(
		issueTypes.map((issueType) => ({
			type: issueType.type_name,
			count: issueType.total_issues,
			totalIssues,
			severity: issueType.severity_name
		})),
		['count'],
		['desc']
	);
};
